import { css } from "@emotion/react";

export const styles = {
  footballcard: css`
    width: 282px;
    border-radius: 16px;
    padding: 0;
    background: #fff;
    height: 100%;
  `,
  footballcard__stack: css`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: inherit;
    justify-content: space-between;
  `,
  footballcard__clickbutton: css`
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    width: 151px;
    height: 48px;
    align-self: center;
    margin-bottom: 20px;
    margin-left: 66px;
    margin-right: 65px;
    margin-top: 24px;
    background: var(--Decorative-Azul-Ipiranga, #0045b5);
    &:hover {
      background-color: #003399;
    }
  `,
  footballcard__button: css`
    display: flex;
    flex-direction: column;
    align-items: inherit;
    flex: 1;
  `,
  footballcard__content: css`
    flex: 1;
    display: flex;
    flex-direction: column;
  `,
  footballcard__image: css`
    width: 80px;
    height: 95.808px;
    object-fit: contain;
    background-size: contain;
  `,
  footballcard__title: css`
    color: #0045b5;
    text-overflow: ellipsis;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px; /* 133.333% */
  `,
  footballcard__stadium: css`
    width: 250px;
    flex-shrink: 0;
    overflow: hidden;
    color: var(--Cores-KMV-Primary-3, #ff8b00);
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    line-height: 140%; /* 22.4px */
    font-weight: 600;
  `,
  footballcard__sector: css`
    color: #ff8b00;
    text-overflow: ellipsis;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  `,

  footballcard__chip: css`
    color: #000000;
  `,
  footballcard__oldprice: css`
    text-decoration: line-through;
    text-overflow: ellipsis;
    color: #939598;
  `,
  footballcard__newprice: css`
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
    text-overflow: ellipsis;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
  `,
  footballcard__kms: css`
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
    text-overflow: ellipsis;
  `,
  footballcard__x: css`
    color: #000000;
    display: flex;
    align-items: center;
    gap: 25px;
  `,
  footballcard__datetime: css`
    align-self: stretch;
    color: var(--_components-chip-defaultCloseFill, #000);
    text-overflow: ellipsis;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 125% */
  `,
  footballcard__actions: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    flex: 1;
    margin-bottom: 36px;
  `,
  footballcard_background: css`
    width: 100%;
    flex-direction: row;
    background: #e5f6fd;
    align-items: center;
    justify-content: space-evenly;
  `,
  footballcard_infos: css`
    display: flex;
    width: 250px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;
    padding-bottom: 0;
    flex-grow: 1;
  `,
  divider: css`
    border: 1px solid var(--_components-chip-defaultHoverFill, rgba(0, 0, 0, 0.12));
    margin-bottom: 16px;
  `
};
